import { GatewayContent } from './general';
import React from 'react';
import { RedirectWatcher } from './RedirectWatcher';
import { SalesforceSyncWatcher } from '@ui/SalesforceSyncWatcher';
import { SessionActivityWatcher } from '@ui/SessionActivityWatcher';
import { Sonar } from '../app/Sonar';
import { When } from 'react-if';
import { OnboardingView, OrganizationView } from './onboarding';
import { useCurrentOrganization, useOnboardingProgress, useOrganizations, useSonarSelector } from '@hooks';
export const AuthorizedView = () => {
    const { loading, progress } = useOnboardingProgress();
    const currentOrganization = useCurrentOrganization();
    const organizationsLoading = useSonarSelector(useOrganizations.selectors.isRequested);
    const ready = !loading && progress &&
        (!organizationsLoading || (organizationsLoading && (currentOrganization === null || currentOrganization === void 0 ? void 0 : currentOrganization.hasSalesforceData)));
    if (!ready) {
        return React.createElement(GatewayContent, null);
    }
    const { isSalesforceConnected, isSalesforceSynced, missingSalesforceSyncPermission } = progress;
    const isOnboarding = !currentOrganization && !progress.organizationId;
    const isRootOrganization = (currentOrganization === null || currentOrganization === void 0 ? void 0 : currentOrganization.id) === progress.organizationId;
    const showOnboarding = isOnboarding || isRootOrganization;
    const showOrganization = !showOnboarding && (!(currentOrganization === null || currentOrganization === void 0 ? void 0 : currentOrganization.hasSalesforceData) || !isSalesforceSynced);
    const showApp = (currentOrganization === null || currentOrganization === void 0 ? void 0 : currentOrganization.hasSalesforceData) &&
        isSalesforceConnected &&
        isSalesforceSynced &&
        !missingSalesforceSyncPermission;
    return (React.createElement(React.Fragment, null,
        React.createElement(SalesforceSyncWatcher, { showNotifications: showApp }),
        React.createElement(SessionActivityWatcher, null),
        React.createElement(RedirectWatcher, null),
        React.createElement(When, { condition: showApp },
            React.createElement(Sonar, null)),
        React.createElement(When, { condition: !showApp && showOnboarding },
            React.createElement(OnboardingView, null)),
        React.createElement(When, { condition: !showApp && showOrganization },
            React.createElement(OrganizationView, null))));
};
